import { Helmet } from 'react-helmet-async';

import OfflineView from 'src/sections/system/error/offline-view';

// ----------------------------------------------------------------------

export default function OfflinePage() {
  return (
    <>
      <Helmet>
        <title>No Internet Connection - PointCraft</title>
      </Helmet>

      <OfflineView />
    </>
  );
}
